var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-row items-center text-xl" },
    [
      _c("font-awesome-icon", {
        staticClass: "mr-3 h-8 fa-spin",
        attrs: { spin: true, icon: _vm.loader }
      }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.message))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }